import { Button, Grid } from '@mui/material';
import { Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccountData, Language, PartialLabelData } from '../../../api';
import TitledDrawer from '../../../common/ui/TitledDrawer';
import { FormTextField } from '../../formComponents/FormTextField';
import { useAuth } from '../../../session/InternalAuthProvider';

type PartialLabelEditDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: (item: PartialLabelData) => void;
  item: PartialLabelData | null;
  title: string;
  fieldLabel: string;
};

type PartialLabelFormValues = {
  en?: string;
  he?: string;
};

export const PartialLabelEditDialog = ({
  open,
  onClose,
  onSave,
  item,
  title,
  fieldLabel,
}: PartialLabelEditDialogProps) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const languages = account.customer_facing_widgets_languages;

  const initialValues: PartialLabelFormValues = {
    en: item?.en || '',
    he: item?.he || '',
  };

  const handleSubmit = (values: PartialLabelFormValues) => {
    onSave(values);
    onClose();
  };

  const isEdit = item !== null;

  return (
    <TitledDrawer title={isEdit ? title : title} open={open} onClose={onClose}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ submitForm }) => (
          <>
            <Grid
              container
              flexDirection="column"
              flexWrap="nowrap"
              gap={2}
              flex={1}
              minHeight={0}
              sx={{
                overflowY: 'auto',
                pt: { xs: '12px', md: '18px' },
                pb: 2,
                paddingInline: { xs: '12px', md: '24px' },
              }}>
              {languages.map((lang) => (
                <FormTextField
                  key={lang}
                  fieldName={lang}
                  label={`${fieldLabel} (${t(`emailTemplates.${lang}`)})`}
                  dir={lang === Language.HE ? 'rtl' : 'ltr'}
                  width="100%"
                  isFieldUpdate
                  minRows={2}
                />
              ))}
            </Grid>
            <Grid
              container
              gap={1}
              justifyContent="flex-end"
              sx={{
                flexShrink: 0,
                py: 1.5,
                paddingInline: { xs: '12px', md: '24px' },
                borderTop: '1px solid',
                borderColor: 'mb.lineSoft',
              }}>
              <Button variant="outlined" color="inherit" onClick={onClose}>
                {t('cancel')}
              </Button>
              <Button variant="contained" onClick={submitForm}>
                {t('save')}
              </Button>
            </Grid>
          </>
        )}
      </Formik>
    </TitledDrawer>
  );
};
